<template>
  <v-navigation-drawer :value="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
    <v-list v-if="items" dense>
      <template v-for="item in items">
        <v-list-group v-if="item.children" :key="item.text" :value="true" no-action>
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(child, i) in item.children" :key="i" :to="child.link" exact>
            <v-list-item-title v-text="child.text"></v-list-item-title>
            <v-list-item-icon>
              <v-icon v-text="child.icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.text" :to="item.link">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    drawer: {
      required: true,
    },
  },
  data() {
    return {
      depositFeeConfig: null,
      transferFeeConfig: null,
      items: null,
    };
  },

  async created() {
    this.items = await this.getLinks();
  },
  methods: {
    async getLinks() {
      let depositFeeConfig = null;
      let transferFeeConfig = null;
      let withdrawFeeConfig = null;
      await this.$http
        .get("/api/v1/transactions/feeConfigurations/deposit")
        .then((data) => (depositFeeConfig = data));
      await this.$http
        .get("/api/v1/transactions/feeConfigurations/transfer")
        .then((data) => (transferFeeConfig = data));

      await this.$http
        .get("/api/v1/transactions/feeConfigurations/cashout")
        .then((data) => (withdrawFeeConfig = data));
      return [
        { icon: "mdi-earth", text: "Dashboard", link: "/" },
        { icon: "mdi-account-group-outline", text: "Users", link:"/users" },
        {
          icon: "mdi-account-multiple-check-outline",
          text: "White listed users",
          children: [
            { icon: "mdi-account-multiple-check-outline", text: "by high risk country", link:"/users/whitelisted/countryhighrisk" },
          ],
        },
        { icon: "mdi-domain", text: "Companies", link: "/companies" },
        { icon: "mdi-account-cash", text: "Deposits", link: "/payins" },
        { icon: "mdi-account-cash-outline", text: "Withdraws", link: "/cashouts" },
        { icon: "mdi-account-cash-outline", text: "Merge Transfers", link: "/merge-transfers" },
        {
          icon: "mdi-bank-transfer",
          text: "Transfers",
          children: [
            { icon: "mdi-bank-transfer-in", text: "Transfers", link: "/transfers" },

            { icon: "mdi-bank-transfer-in", text: "Bulk Transfers", link: "/bulktransfers" },

            { icon: "mdi-cash", text: "BankAccounts", link: "/accounts/bankaccounts" },
          ],
        },
        { icon: "mdi-cash-check", text: "Escrow Transfers", link: "/escrowTransfers" },
        {
          icon: "mdi-police-badge",
          text: "Compliance",
          children: [
            { icon: "mdi-fridge-bottom", text: "Gels des avoirs", link: "/criminalCases" },
          ],
        },
        { icon: "mdi-wallet-outline", text: "Crypto", link: "/crypto" },
        {
          icon: "mdi-bank-transfer",
          text: "Marketing",
          children: [
            { icon: "mdi-account-group-outline", text: "influencers", link: "/influencers" },
            { icon: "mdi-rv-truck", text: "Campaigns", link: "/campaigns" },
            { icon: "mdi-cash-check", text: "Customer Rewards", link: "/customerRewards" },
          ],
        },
        { icon: "mdi-table-account", text: "Accounting", link: "/transfers/accounting" },

        {
          icon: "mdi-cog-transfer",
          text: "Fee Configurations",
          // link: "/transferConfigurations/paymentTypes",
          children: [
            {
              icon: "mdi-cash-lock-open",
              text: "Deposit",
              link: `/feeConfigurations/${depositFeeConfig.id}/deposits/offers`,
            },
            {
              icon: "mdi-cash-lock-open",
              text: "Instant Transfer",
              //   link: "/feeConfigurations/instantTransfers",
              link: `/feeConfigurations/${transferFeeConfig.id}/instantTransfers/offers`,
            },
            {
              icon: "mdi-cash-lock-open",
              text: "Withdraw",
              link: `/feeConfigurations/${withdrawFeeConfig.id}/withdraws/offers`,
            },
          ],
        },
        {
          icon: "mdi-bank-transfer",
          text: "Configurations",
          children: [
            {
              icon: "mdi-cog-transfer",
              text: "Platform Configurations",
              link: "/platformConfigurations/paymentTypes",
            },
            {
              icon: "mdi-cog-transfer",
              text: "Hub2 Operator Mapping",
              link: "/cloudBanking/Hub2/institutions",
            },
            {
              icon: "mdi-cog-transfer",
              text: "Internal Bank Mapping",
              link: "/cloudBanking/danapay/institutions",
            },
            {
              icon: "mdi-cog-transfer",
              text: "Aloohpay Operator Mapping",
              link: "/cloudBanking/aloohpay/institutions",
            },
            {
              icon: "mdi-cog-transfer",
              text: "Neero Operator Mapping",
              link: "/cloudBanking/Neero/institutions",
            },
            {
              icon: "mdi-cash-multiple",
              text: "Distribution Configuration(Earning Structure)",
              link: "/earningStructure",
            },
            {
              icon: "mdi-bitcoin",
              text: "Crypto Configurations",
              link: "/cryptoConfigurations/paymentTypes",
            },
          ],
        },
      ];
    },
  },
};
</script>
